export enum ENVIRONMENTS {
  STAGING = "staging",
  PRODUCTION = "production",
  LOCAL_SHEHAN = "local_shehan",
  LOCAL_ALI = "local_ali",
  LOCAL_SHAYAN = "local_shayan",
}
export const ENVIRONMENT_MODE: string = ENVIRONMENTS.STAGING;

export const BASE_URLS: {
  [key: string]: {
    REACT_APP_API_BASE_URL: string;
    REACT_APP_EMAIL_URL: string;
  };
} = {
  production: {
    REACT_APP_API_BASE_URL: "https://backend.landscaling.com/",
    REACT_APP_EMAIL_URL: "https://app.landscaling.com",
  },
  staging: {
    REACT_APP_API_BASE_URL: "https://www.landscalingapi.darkhorsesolutions.co/",
    REACT_APP_EMAIL_URL: "https://landscaling.darkhorsesolutions.co",
  },
  local_shehan: {
    REACT_APP_API_BASE_URL: "http://192.168.100.95:3000/",
    REACT_APP_EMAIL_URL: "http://192.168.100.10:3000",
  },
  local_shayan: {
    REACT_APP_API_BASE_URL: "http://192.168.100.62:3000/",
    REACT_APP_EMAIL_URL: "http://192.168.100.10:3000",
  },
  local_ali: {
    REACT_APP_API_BASE_URL: "http://192.168.100.7:3000/",
    REACT_APP_EMAIL_URL: "http://192.168.100.10:3000",
  },
};
